import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { GiftCard } from './pages/GiftCard';
import { VirtualCard } from './pages/VirtualCard';
import { Crypto } from './pages/Crypto';
import { CryptoSwap } from './pages/CryptoSwap';
import { Savings } from './pages/Savings';
import { BillPayment } from './pages/BillPayment';
import { NinPrinting } from './pages/NinPrinting';
import { Support } from './pages/Support';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
          <Route index element={<Dashboard data-id="element-6" />} data-id="element-5" />
          <Route path="gift-cards" element={<GiftCard data-id="element-8" />} data-id="element-7" />
          <Route path="virtual-cards" element={<VirtualCard data-id="element-10" />} data-id="element-9" />
          <Route path="crypto" element={<Crypto data-id="element-12" />} data-id="element-11" />
          <Route path="crypto-swap" element={<CryptoSwap data-id="element-14" />} data-id="element-13" />
          <Route path="savings" element={<Savings data-id="element-16" />} data-id="element-15" />
          <Route path="bill-payment" element={<BillPayment data-id="element-18" />} data-id="element-17" />
          <Route path="nin-printing" element={<NinPrinting data-id="element-20" />} data-id="element-19" />
          <Route path="support" element={<Support data-id="element-22" />} data-id="element-21" />
        </Route>
      </Routes>
    </BrowserRouter>;
}